const env = import.meta.env;

// * NODE_ENV does not exist on Vite, instead Vite sets a MODE variable to development when serving and production when building by default
// * Custom modes can also be set using --mode (more info here https://vitejs.dev/guide/env-and-mode.html#modes)
const {
  MODE: NODE_ENV,
  REACT_APP_API_ENDPOINT,
  REACT_APP_WEBCLIENT_URL,
  REACT_APP_FB_GRAPH_VERSION,
  REACT_APP_FB_LOGIN_REDIRECT_ENDPOINT,
  REACT_APP_ENVIRONMENT,
  REACT_APP_CLARITY_PROJECT_ID,
  REACT_APP_MICROSOFT_SSO_CLIENT_ID,
  REACT_APP_MICROSOFT_SSO_REDIRECT_URL,
  REACT_MAX_MEDIA_FILE_SIZE,
  REACT_MAX_DOCUMENT_FILE_SIZE,
} = env;

export const API_ENDPOINT = REACT_APP_API_ENDPOINT || '';
export const IS_DEVELOPMENT_ENVIRONMENT = NODE_ENV === 'development';
export const APP_ENVIRONMENT = REACT_APP_ENVIRONMENT;
export const WS_ENDPOINT = REACT_APP_API_ENDPOINT || '';
export const FB_GRAPH_VERSION = REACT_APP_FB_GRAPH_VERSION || 'v10.0';
export const WEBCLIENT_URL = REACT_APP_WEBCLIENT_URL;
export const FB_INTEGRATION_CREATE_ENDPOINT =
  REACT_APP_FB_LOGIN_REDIRECT_ENDPOINT || '/integrations/facebook';
export const CLARITY_PROJECT_ID = REACT_APP_CLARITY_PROJECT_ID || '';
export const MICROSOFT_SSO_CLIENT_ID = REACT_APP_MICROSOFT_SSO_CLIENT_ID || '';
export const MICROSOFT_SSO_REDIRECT_URL =
  REACT_APP_MICROSOFT_SSO_REDIRECT_URL || '';
export const MAX_MEDIA_FILE_SIZE =
  REACT_MAX_MEDIA_FILE_SIZE && !Number.isNaN(Number(REACT_MAX_MEDIA_FILE_SIZE))
    ? Number(REACT_MAX_MEDIA_FILE_SIZE)
    : 5000000; // Default to 5MB
export const MAX_DOCUMENT_FILE_SIZE =
  REACT_MAX_DOCUMENT_FILE_SIZE &&
  !Number.isNaN(Number(REACT_MAX_DOCUMENT_FILE_SIZE))
    ? Number(REACT_MAX_DOCUMENT_FILE_SIZE)
    : 30000000; // Default to 30MB
